// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
// api
import * as ppa from './api/ppa';
import * as rms from './api/rms';
import * as admin from './api/embedadmin';

// thunks
export const fetchAccountRevenueShare = createAsyncThunk('settings/fetchAccountRevenueShare', async requestData => {
  const { localeDate, accountUUID } = requestData;
  const response = await ppa.getAccountRevenueShare(localeDate, accountUUID);
  return response.data
});

export const updateAccountRevenueShare = createAsyncThunk('settings/updateAccountRevenueShare', async requestData => {
  const { accountUUID, revenueShare } = requestData;
  const response = await ppa.updateAccountRevenueShare(accountUUID, revenueShare);
  return response.data
})

export const fetchSiteRevenueShare = createAsyncThunk('settings/fetchSiteRevenueShare', async requestData => {
  const { localeDate, accountUUID } = requestData;
  const response = await ppa.getSiteRevenueShare(localeDate, accountUUID);
  return response.data
})

export const updateSiteRevenueShare = createAsyncThunk('settings/updateSiteRevenueShare', async requestData => {
  const { accountUUID, revenueShare } = requestData;
  const response = await ppa.updateSiteRevenueShare(accountUUID, revenueShare);
  return response.data
})

export const fetchInvoiceConfig = createAsyncThunk('settings/fetchInvoiceConfig', async accountUUID => {
  const response = await ppa.getAccountSettings(accountUUID)
  return response.data
})

export const updateInvoiceConfig = createAsyncThunk('settings/updateInvoiceConfig', async requestData => {
  const response = await ppa.updateAccountSettings(requestData);
  return response.data
})

export const fetchLatestProductRevenueDeduction = createAsyncThunk('settings/fetchLatestProductRevenueDeduction', async date => {
  const response = await rms.getLatestProductRevenueDeduction(date);
  return response.data
})

export const fetchLatestProductRevenueDeductionForAccount = createAsyncThunk('settings/fetchLatestProductRevenueDeductionForAccount', async requestData => {
  const { localeDate, accountUUID } = requestData;
  const response = await rms.getLatestProductRevenueDeductionForAccount(localeDate,accountUUID);
  return response.data
})

export const updateProductRevenueDeduction = createAsyncThunk('settings/updateProductRevenueDeduction', async requestData => {
  const response = await ppa.updateProductRevenueDeduction(requestData)
  return response.data
})

export const updateProductRevenueDeductionForAccount = createAsyncThunk('settings/updateProductRevenueDeductionForAccount', async payload => {
  let { accountUUID, requestData } = payload;
  const response = await ppa.updateProductRevenueDeductionForAccount(accountUUID, requestData)
  return response.data
})

export const fetchDashboardMessage = createAsyncThunk('settings/fetchDashboardMessage', async () => {
  const response = await ppa.getDashboardMessage()
  return response.data
})

export const updateDashboardMessage = createAsyncThunk('settings/updateDashboardMessage', async requestData => {
  const response = await ppa.updateDashboardMessage(requestData)
  return response.data
})

export const fetchReportApiKey = createAsyncThunk('settings/fetchReportApiKey', async payload => {
  const response = await ppa.getReportApiKey(payload)
  return response.data
})

export const createReportApiKey = createAsyncThunk('settings/createReportApiKey', async payload => {
  const response = await ppa.createReportApiKey(payload)
  return response.data
})


